import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import intelligentOutboundCallModelAPI from '../apis/intelligentOutboundCallModelAPI'
import alertMessage from '../utils/alertMessage'

export default class IntelligentOutboundCallModelStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  /*SearchResult start*/
  @observable searchItem = {
    'groupName': '',
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await intelligentOutboundCallModelAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallModelAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null
  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallModelAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'groupName': this.searchItem.groupName,
      'isPowerUser': this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }

  // 测试发送加载状态
  @observable bindList = []
  @action
  async onBindAction(params) {
    this.bindList = [];
    try {
      const response = await intelligentOutboundCallModelAPI.bindAction(params)
      const { code, data, messageEn } = response?.data
      runInAction(() => {
        if (code === 0) {
          this.bindList = data
        } else {
          alertMessage.error('获取失败' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isTestSendFetching = false;
      })
    }
  }
    /*status*/
    @action
    async onChangeStatus(apiID) {
      this.isFetching = true
      try {
        const response = await intelligentOutboundCallModelAPI.statusAction(apiID)
        runInAction(() => {
          this.isFetching = false
          // if (response.data.code === 200) {
          if (response.data.code === 0) {
            alertMessage.success('操作成功！')
            this.onSearchJobAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          } else {
            alertMessage.error('操作失败！' + response.data.data + '')
          }
        })
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetching = false
        })
      }
    }
}
